<template>
  <vl-feature :id="featureId" ref="feature" :properties="{ username }">
    <vl-geom-point :coordinates="coordinates" />
    <vl-style-box :z-index="latitude + longitude">
      <vl-style-icon
        :src="icon.url"
        :anchor="[0.5, 46]"
        anchor-x-units="fraction"
        anchor-y-units="pixels"
      />
      <vl-style-text
        :text="userLabel"
        font="16px/1 Nunito, sans serif"
        text-baseline="bottom"
        :offset-y="parseFloat(-2)"
      >
        <vl-style-fill color="white" />
      </vl-style-text>
    </vl-style-box>
  </vl-feature>
</template>
<script>
import Vue from 'vue';
import { fromLonLat } from 'ol/proj';

import VueLayers from 'vuelayers';
import 'vuelayers/lib/style.css';

Vue.use(VueLayers);

// Shared across all markers: the visual variants are a small closed set (vehicle type x
// highlight x filter state), so every marker with the same visual state reuses the same
// data-URI instead of OpenLayers decoding a brand new image/texture per marker per update.
const iconUrlCache = {};

function getIconUrl(isInspector, pinFill, highlightOpacity) {
  const key = `${isInspector}-${pinFill}-${highlightOpacity}`;
  if (!iconUrlCache[key]) {
    const inspectorPin =
      'm18.5890625 21.471875 12.8125-8.471875 12.815625 8.471875h12.7828125v22.8578125h-12.6140625v.10625l-12.984375 7.0515625-12.990625-7.05625v-.1015625h-11.4109375v-22.8578125z';
    const busPin =
      'M18.1,43.3H7V20.4h11.4c3.3-3.8,8.1-6.2,13.6-6.2c5.4,0,10.3,2.4,13.6,6.2H57v22.9H45.9c-3.4,4.2-8.5,6.6-13.9,6.6C26.4,49.9,21.4,47.3,18.1,43.3z';

    const icon = `
      <svg height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" fill="#3cb1a1" fill-opacity="${highlightOpacity}" r="32"/>
        <path d="${
          isInspector ? inspectorPin : busPin
        }" fill="${pinFill}" fill-rule="nonzero" stroke="#fffefb"/>
      </svg>
    `;

    iconUrlCache[key] =
      'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon);
  }
  return iconUrlCache[key];
}

export default {
  props: {
    username: {
      type: String,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    latitude: {
      type: Number,
      required: true,
    },
    featureId: {
      type: String,
      required: true,
    },
  },
  computed: {
    coordinates() {
      return fromLonLat([this.longitude, this.latitude], 'EPSG:3857');
    },

    user() {
      return this.$store.getters['users/getUserByUsername'](this.username);
    },

    participateInCurrentCall() {
      return this.$store.getters['voip/participateInCurrentCall'](
        this.username
      );
    },

    userLabel() {
      if (this.user) {
        if (this.user.type === 'bus') {
          return this.user.details.vehicle_no;
        } else if (this.user.type === 'inspector') {
          return this.user.details.matricule;
        }
      }
      return '?';
    },

    icon() {
      const isInspector = this.user && this.user.type === 'inspector';
      const pinFill = this.$store.getters['live/userHasFilters'](this.user)
        ? '#319B8D'
        : '#464a52';
      const highlightOpacity = this.participateInCurrentCall ? '0.3' : '0';

      return { url: getIconUrl(isInspector, pinFill, highlightOpacity) };
    },
  },
  methods: {},
};
</script>
